module.exports = "<p>\r\n  blog-list works!\r\n</p>\r\n"